import {
  ITextAreaFieldConfigurationClient,
  ITextAreaFieldConfigurationServer,
} from "./interface";

export const transformTextAreaFieldConfigClientToServer = (
  fieldConfigClient: ITextAreaFieldConfigurationClient
): ITextAreaFieldConfigurationServer => {
  const { placeholder, initialValue, writeJavascript } = fieldConfigClient;
  const fieldConfigServer = {
    placeHolder: placeholder,
    initialValue: initialValue,
    writeJavascript: writeJavascript,
  };
  return fieldConfigServer;
};

export const transformTextAreatConfigServerToClient = (
  fieldConfigServer: ITextAreaFieldConfigurationServer
): ITextAreaFieldConfigurationClient => {
  const { placeHolder, initialValue, writeJavascript } = fieldConfigServer;
  const fieldConfigClient = {
    placeholder: placeHolder,
    initialValue: initialValue,
    writeJavascript: writeJavascript,
  };
  return fieldConfigClient;
};
